module.exports = __webpack_public_path__ + "static/media/431064682_1502640326954707_306642889270202318_n (1).f0b7ed7e.jpg";